export enum CurrencyCode {
  BTC = "BTC",
  CZK = "CZK",
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
  PLN = "PLN",
  CHF = "CHF",
}
